export default [
  {
    date: 1516914714796,
    row: 21,
    col: 33,
    squares: [
      [1, 12, "#000000"],
      [1, 13, "#000000"],
      [1, 14, "#000000"],
      [1, 15, "#000000"],
      [1, 16, "#000000"],
      [1, 17, "#000000"],
      [1, 18, "#000000"],
      [1, 19, "#000000"],
      [1, 20, "#000000"],
      [1, 21, "#000000"],
      [1, 22, "#000000"],
      [2, 11, "#000000"],
      [2, 10, "#000000"],
      [2, 24, "#000000"],
      [3, 9, "#000000"],
      [3, 8, "#000000"],
      [4, 8, "#FFFF00"],
      [4, 7, "#000000"],
      [4, 6, "#000000"],
      [5, 6, "#FFFF00"],
      [5, 5, "#000000"],
      [6, 5, "#FFFF00"],
      [6, 4, "#000000"],
      [7, 4, "#FFFF00"],
      [8, 4, "#000000"],
      [8, 3, "#FFFF00"],
      [9, 3, "#FFFF00"],
      [10, 3, "#FFFF00"],
      [11, 3, "#FFFF00"],
      [12, 3, "#FFFF00"],
      [13, 3, "#FFFF00"],
      [13, 4, "#000000"],
      [14, 4, "#FFFF00"],
      [15, 4, "#000000"],
      [15, 5, "#FFFF00"],
      [16, 5, "#000000"],
      [16, 6, "#FFFF00"],
      [17, 6, "#000000"],
      [17, 7, "#000000"],
      [17, 8, "#FFFF00"],
      [18, 8, "#000000"],
      [18, 9, "#000000"],
      [18, 10, "#FFFF00"],
      [19, 10, "#000000"],
      [19, 11, "#000000"],
      [19, 12, "#000000"],
      [19, 13, "#FFFF00"],
      [19, 14, "#FFFF00"],
      [20, 13, "#000000"],
      [20, 14, "#000000"],
      [20, 15, "#FFFF00"],
      [20, 16, "#FFFF00"],
      [20, 17, "#FFFF00"],
      [20, 18, "#FFFF00"],
      [20, 19, "#FFFF00"],
      [20, 20, "#FFFF00"],
      [20, 21, "#000000"],
      [20, 22, "#000000"],
      [20, 23, "#000000"],
      [19, 22, "#FFFF00"],
      [19, 23, "#FFFF00"],
      [19, 24, "#FFFF00"],
      [19, 25, "#000000"],
      [19, 26, "#000000"],
      [18, 26, "#FFFF00"],
      [18, 27, "#000000"],
      [17, 27, "#FFFF00"],
      [17, 28, "#FFFF00"],
      [17, 29, "#000000"],
      [16, 29, "#FFFF00"],
      [16, 30, "#000000"],
      [15, 30, "#FFFF00"],
      [15, 31, "#000000"],
      [14, 31, "#000000"],
      [13, 31, "#FFFF00"],
      [13, 32, "#000000"],
      [12, 32, "#000000"],
      [11, 32, "#000000"],
      [10, 32, "#000000"],
      [9, 32, "#000000"],
      [8, 32, "#000000"],
      [3, 25, "#000000"],
      [3, 26, "#000000"],
      [4, 27, "#000000"],
      [4, 28, "#000000"],
      [5, 29, "#000000"],
      [6, 30, "#000000"],
      [8, 31, "#000000"],
      [7, 31, "#000000"],
      [3, 15, "#000000"],
      [3, 19, "#000000"],
      [4, 15, "#000000"],
      [4, 16, "#000000"],
      [4, 17, "#000000"],
      [4, 18, "#000000"],
      [4, 19, "#000000"],
      [5, 15, "#000000"],
      [5, 16, "#000000"],
      [5, 17, "#000000"],
      [5, 18, "#000000"],
      [5, 19, "#000000"],
      [6, 15, "#000000"],
      [6, 16, "#000000"],
      [6, 17, "#000000"],
      [6, 18, "#000000"],
      [6, 19, "#000000"],
      [7, 15, "#000000"],
      [7, 17, "#000000"],
      [7, 16, "#000000"],
      [7, 18, "#000000"],
      [7, 19, "#000000"],
      [8, 14, "#000000"],
      [8, 15, "#000000"],
      [8, 16, "#000000"],
      [8, 17, "#000000"],
      [8, 18, "#000000"],
      [8, 19, "#000000"],
      [8, 20, "#000000"],
      [8, 23, "#000000"],
      [9, 23, "#000000"],
      [9, 22, "#000000"],
      [9, 21, "#000000"],
      [9, 20, "#000000"],
      [9, 19, "#000000"],
      [9, 18, "#000000"],
      [9, 17, "#000000"],
      [9, 16, "#000000"],
      [9, 15, "#000000"],
      [9, 14, "#000000"],
      [9, 13, "#000000"],
      [9, 12, "#000000"],
      [9, 11, "#000000"],
      [8, 11, "#000000"],
      [4, 11, "#000000"],
      [4, 10, "#000000"],
      [5, 10, "#000000"],
      [6, 10, "#000000"],
      [7, 10, "#000000"],
      [8, 10, "#000000"],
      [9, 10, "#000000"],
      [6, 9, "#000000"],
      [6, 8, "#000000"],
      [7, 8, "#000000"],
      [7, 9, "#000000"],
      [4, 23, "#000000"],
      [4, 24, "#000000"],
      [1, 23, "#000000"],
      [2, 25, "#000000"],
      [5, 24, "#000000"],
      [6, 24, "#000000"],
      [7, 24, "#000000"],
      [8, 24, "#000000"],
      [9, 24, "#000000"],
      [5, 25, "#000000"],
      [3, 27, "#000000"],
      [6, 25, "#000000"],
      [6, 26, "#000000"],
      [6, 27, "#000000"],
      [4, 29, "#000000"],
      [5, 30, "#000000"],
      [7, 27, "#000000"],
      [7, 28, "#000000"],
      [7, 29, "#000000"],
      [6, 31, "#000000"],
      [8, 29, "#000000"],
      [9, 30, "#000000"],
      [10, 30, "#000000"],
      [11, 30, "#000000"],
      [7, 25, "#000000"],
      [12, 30, "#000000"],
      [13, 30, "#000000"],
      [14, 30, "#FFFF00"],
      [9, 31, "#FFFF00"],
      [10, 31, "#FFFF00"],
      [11, 31, "#FFFF00"],
      [12, 31, "#FFFF00"],
      [14, 32, "#000000"],
      [14, 29, "#000000"],
      [14, 28, "#000000"],
      [15, 29, "#000000"],
      [16, 28, "#FFFF00"],
      [15, 28, "#000000"],
      [15, 27, "#000000"],
      [16, 27, "#000000"],
      [17, 30, "#000000"],
      [16, 31, "#000000"],
      [18, 29, "#000000"],
      [18, 28, "#000000"],
      [17, 26, "#000000"],
      [14, 27, "#000000"],
      [13, 26, "#000000"],
      [13, 27, "#000000"],
      [13, 28, "#000000"],
      [13, 29, "#000000"],
      [12, 26, "#000000"],
      [11, 26, "#000000"],
      [10, 26, "#000000"],
      [9, 26, "#000000"],
      [8, 26, "#000000"],
      [7, 26, "#000000"],
      [8, 27, "#000000"],
      [8, 28, "#000000"],
      [9, 29, "#000000"],
      [9, 28, "#000000"],
      [9, 27, "#000000"],
      [10, 27, "#000000"],
      [10, 28, "#000000"],
      [10, 29, "#000000"],
      [11, 29, "#000000"],
      [11, 28, "#000000"],
      [11, 27, "#000000"],
      [12, 27, "#000000"],
      [12, 28, "#000000"],
      [12, 29, "#000000"],
      [18, 25, "#FFFF00"],
      [18, 24, "#FFFF00"],
      [19, 21, "#FFFF00"],
      [20, 24, "#000000"],
      [20, 25, "#000000"],
      [19, 20, "#FFFF00"],
      [18, 20, "#FFFF00"],
      [21, 22, "#000000"],
      [21, 21, "#000000"],
      [21, 20, "#000000"],
      [21, 19, "#000000"],
      [21, 18, "#000000"],
      [21, 17, "#000000"],
      [21, 16, "#000000"],
      [21, 15, "#000000"],
      [21, 14, "#000000"],
      [21, 13, "#000000"],
      [20, 12, "#000000"],
      [20, 11, "#000000"],
      [19, 15, "#FFFF00"],
      [19, 16, "#FFFF00"],
      [19, 17, "#FFFF00"],
      [19, 18, "#FFFF00"],
      [19, 19, "#FFFF00"],
      [12, 25, "#000000"],
      [12, 24, "#000000"],
      [13, 23, "#000000"],
      [14, 22, "#000000"],
      [13, 22, "#000000"],
      [15, 22, "#000000"],
      [16, 22, "#FFFF00"],
      [13, 21, "#000000"],
      [13, 20, "#000000"],
      [13, 19, "#000000"],
      [14, 19, "#000000"],
      [15, 18, "#000000"],
      [15, 17, "#000000"],
      [16, 17, "#000000"],
      [17, 17, "#000000"],
      [15, 16, "#000000"],
      [14, 15, "#000000"],
      [13, 15, "#000000"],
      [14, 16, "#000000"],
      [14, 17, "#000000"],
      [14, 18, "#000000"],
      [13, 14, "#000000"],
      [13, 13, "#000000"],
      [13, 12, "#000000"],
      [14, 12, "#000000"],
      [15, 12, "#000000"],
      [16, 23, "#FFFF00"],
      [13, 24, "#FFFF00"],
      [13, 25, "#FFFF00"],
      [14, 26, "#FFFF00"],
      [14, 25, "#FFFF00"],
      [14, 24, "#FFFF00"],
      [14, 23, "#FFFF00"],
      [15, 23, "#FFFF00"],
      [15, 24, "#FFFF00"],
      [15, 25, "#FFFF00"],
      [15, 26, "#FFFF00"],
      [16, 26, "#FFFF00"],
      [16, 25, "#FFFF00"],
      [16, 24, "#FFFF00"],
      [17, 25, "#FFFF00"],
      [17, 23, "#FFFF00"],
      [18, 23, "#FFFF00"],
      [17, 22, "#FFFF00"],
      [18, 22, "#FFFF00"],
      [17, 24, "#FFFF00"],
      [18, 21, "#FFFF00"],
      [14, 21, "#FFFF00"],
      [15, 21, "#FFFF00"],
      [16, 21, "#FFFF00"],
      [17, 21, "#FFFF00"],
      [14, 20, "#FFFF00"],
      [15, 20, "#FFFF00"],
      [16, 20, "#FFFF00"],
      [17, 20, "#FFFF00"],
      [15, 19, "#FFFF00"],
      [16, 19, "#FFFF00"],
      [17, 19, "#FFFF00"],
      [18, 19, "#FFFF00"],
      [16, 18, "#FFFF00"],
      [17, 18, "#FFFF00"],
      [18, 18, "#FFFF00"],
      [18, 16, "#FFFF00"],
      [18, 17, "#FFFF00"],
      [8, 25, "#000000"],
      [9, 25, "#000000"],
      [10, 25, "#000000"],
      [11, 25, "#000000"],
      [10, 24, "#000000"],
      [11, 24, "#000000"],
      [12, 23, "#000000"],
      [11, 23, "#000000"],
      [10, 23, "#000000"],
      [10, 22, "#000000"],
      [11, 22, "#000000"],
      [12, 22, "#000000"],
      [10, 21, "#000000"],
      [13, 16, "#000000"],
      [13, 17, "#000000"],
      [13, 18, "#000000"],
      [12, 21, "#000000"],
      [11, 21, "#000000"],
      [10, 20, "#000000"],
      [11, 20, "#000000"],
      [12, 20, "#000000"],
      [12, 19, "#000000"],
      [11, 19, "#000000"],
      [10, 19, "#000000"],
      [10, 18, "#000000"],
      [11, 18, "#000000"],
      [12, 18, "#000000"],
      [12, 17, "#000000"],
      [11, 17, "#000000"],
      [10, 17, "#000000"],
      [10, 16, "#000000"],
      [11, 16, "#000000"],
      [12, 16, "#000000"],
      [10, 15, "#000000"],
      [11, 15, "#000000"],
      [12, 15, "#000000"],
      [12, 14, "#000000"],
      [11, 14, "#000000"],
      [10, 14, "#000000"],
      [13, 11, "#000000"],
      [12, 11, "#000000"],
      [11, 11, "#000000"],
      [10, 11, "#000000"],
      [10, 12, "#000000"],
      [11, 12, "#000000"],
      [12, 12, "#000000"],
      [12, 13, "#000000"],
      [11, 13, "#000000"],
      [10, 13, "#000000"],
      [12, 10, "#000000"],
      [12, 9, "#000000"],
      [12, 8, "#000000"],
      [13, 8, "#000000"],
      [14, 7, "#000000"],
      [15, 7, "#000000"],
      [16, 8, "#000000"],
      [16, 7, "#FFFF00"],
      [15, 6, "#FFFF00"],
      [17, 9, "#FFFF00"],
      [14, 8, "#FFFF00"],
      [15, 8, "#FFFF00"],
      [15, 9, "#FFFF00"],
      [16, 9, "#FFFF00"],
      [17, 10, "#FFFF00"],
      [18, 11, "#FFFF00"],
      [18, 12, "#FFFF00"],
      [18, 13, "#FFFF00"],
      [13, 9, "#FFFF00"],
      [14, 9, "#FFFF00"],
      [13, 10, "#FFFF00"],
      [14, 10, "#FFFF00"],
      [15, 10, "#FFFF00"],
      [16, 10, "#FFFF00"],
      [14, 11, "#FFFF00"],
      [15, 11, "#FFFF00"],
      [16, 11, "#FFFF00"],
      [16, 12, "#FFFF00"],
      [17, 12, "#FFFF00"],
      [17, 11, "#FFFF00"],
      [14, 13, "#FFFF00"],
      [14, 14, "#FFFF00"],
      [15, 14, "#FFFF00"],
      [15, 13, "#FFFF00"],
      [16, 13, "#FFFF00"],
      [17, 13, "#FFFF00"],
      [17, 14, "#FFFF00"],
      [16, 14, "#FFFF00"],
      [15, 15, "#FFFF00"],
      [16, 15, "#FFFF00"],
      [16, 16, "#FFFF00"],
      [17, 16, "#FFFF00"],
      [17, 15, "#FFFF00"],
      [18, 14, "#FFFF00"],
      [18, 15, "#FFFF00"],
      [19, 9, "#000000"],
      [18, 7, "#000000"],
      [17, 5, "#000000"],
      [16, 4, "#000000"],
      [12, 4, "#000000"],
      [14, 6, "#000000"],
      [14, 5, "#000000"],
      [14, 3, "#000000"],
      [15, 3, "#000000"],
      [13, 6, "#000000"],
      [12, 6, "#000000"],
      [12, 7, "#000000"],
      [13, 7, "#000000"],
      [13, 5, "#000000"],
      [12, 5, "#000000"],
      [13, 2, "#000000"],
      [12, 2, "#000000"],
      [11, 2, "#000000"],
      [10, 2, "#000000"],
      [9, 2, "#000000"],
      [8, 2, "#000000"],
      [11, 4, "#000000"],
      [10, 4, "#000000"],
      [9, 4, "#000000"],
      [7, 3, "#000000"],
      [6, 3, "#000000"],
      [7, 2, "#000000"],
      [6, 6, "#FFFF00"],
      [7, 5, "#000000"],
      [8, 5, "#000000"],
      [9, 5, "#000000"],
      [10, 5, "#000000"],
      [11, 5, "#000000"],
      [7, 6, "#000000"],
      [8, 6, "#000000"],
      [9, 6, "#000000"],
      [10, 6, "#000000"],
      [11, 6, "#000000"],
      [5, 7, "#FFFF00"],
      [5, 8, "#FFFF00"],
      [6, 7, "#000000"],
      [7, 7, "#000000"],
      [5, 4, "#000000"],
      [4, 5, "#000000"],
      [3, 7, "#000000"],
      [3, 11, "#FFFF00"],
      [3, 10, "#FFFF00"],
      [1, 11, "#000000"],
      [2, 9, "#000000"],
      [4, 9, "#FFFF00"],
      [5, 9, "#000000"],
      [8, 9, "#000000"],
      [9, 9, "#000000"],
      [10, 9, "#000000"],
      [11, 9, "#000000"],
      [11, 7, "#000000"],
      [11, 8, "#000000"],
      [10, 8, "#000000"],
      [9, 8, "#000000"],
      [8, 8, "#000000"],
      [8, 7, "#000000"],
      [9, 7, "#000000"],
      [10, 7, "#000000"],
      [10, 10, "#000000"],
      [11, 10, "#000000"],
      [2, 12, "#FFFF00"],
      [3, 12, "#FFFF00"],
      [4, 12, "#FFFF00"],
      [5, 12, "#FFFF00"],
      [6, 12, "#FFFF00"],
      [7, 12, "#FFFF00"],
      [8, 12, "#FFFF00"],
      [8, 13, "#FFFF00"],
      [7, 11, "#FFFF00"],
      [6, 11, "#FFFF00"],
      [5, 11, "#FFFF00"],
      [7, 13, "#FFFF00"],
      [6, 13, "#FFFF00"],
      [5, 13, "#FFFF00"],
      [4, 13, "#FFFF00"],
      [3, 13, "#FFFF00"],
      [2, 13, "#FFFF00"],
      [2, 14, "#FFFF00"],
      [3, 14, "#FFFF00"],
      [4, 14, "#FFFF00"],
      [5, 14, "#FFFF00"],
      [6, 14, "#FFFF00"],
      [7, 14, "#FFFF00"],
      [2, 15, "#FFFF00"],
      [2, 16, "#FFFF00"],
      [3, 16, "#FFFF00"],
      [3, 17, "#FFFF00"],
      [2, 17, "#FFFF00"],
      [2, 18, "#FFFF00"],
      [3, 18, "#FFFF00"],
      [2, 19, "#FFFF00"],
      [2, 20, "#FFFF00"],
      [3, 20, "#FFFF00"],
      [4, 20, "#FFFF00"],
      [5, 20, "#FFFF00"],
      [6, 20, "#FFFF00"],
      [7, 20, "#FFFF00"],
      [8, 21, "#FFFF00"],
      [8, 22, "#FFFF00"],
      [7, 22, "#FFFF00"],
      [7, 21, "#FFFF00"],
      [6, 21, "#FFFF00"],
      [6, 22, "#FFFF00"],
      [6, 23, "#FFFF00"],
      [7, 23, "#FFFF00"],
      [5, 23, "#FFFF00"],
      [5, 22, "#FFFF00"],
      [5, 21, "#FFFF00"],
      [4, 21, "#FFFF00"],
      [4, 22, "#FFFF00"],
      [3, 21, "#FFFF00"],
      [3, 22, "#FFFF00"],
      [3, 23, "#FFFF00"],
      [3, 24, "#FFFF00"],
      [2, 23, "#FFFF00"],
      [2, 22, "#FFFF00"],
      [2, 21, "#FFFF00"],
      [4, 25, "#FFFF00"],
      [4, 26, "#FFFF00"],
      [5, 26, "#FFFF00"],
      [5, 27, "#FFFF00"],
      [5, 28, "#FFFF00"],
      [6, 28, "#FFFF00"],
      [6, 29, "#FFFF00"],
      [7, 30, "#FFFF00"],
      [8, 30, "#FFFF00"],
      [14, 2, "#000000"],
    ],
  },
];
